import { types } from "../constants/types";

const initialState = {

    createPaymentRequestData : [],
    createPaymentRequestDataFailed : '',

    getAllTransaction: [],
    getAllTransactionFailed: '',

    getTransactionByUserId: [],
    getTransactionByUserIdFailed: '',

    sendWhatsAppPaymentLink: [],
    sendWhatsAppPaymentLinkFailed: '',

}

//receives the current state and an action object
export function paymentReducer(state = initialState, action) {
    switch (action.type) {
        case types.CREATE_PAYMENT_REQUEST_DATA_SUCCESS:
            return {
                ...state,
                createPaymentRequestData : action.payload
            }
        case types.CREATE_PAYMENT_REQUEST_DATA_FAILED:
            return {
                ...state,
                createPaymentRequestDataFailed : action.payload
            }
        case types.SEND_WHATSAPP_PAYMENT_LINK_SUCCESS:
            return {
                ...state,
                sendWhatsAppPaymentLink : action.payload
            }
        case types.SEND_WHATSAPP_PAYMENT_LINK_FAILED:
            return {
                ...state,
                sendWhatsAppPaymentLinkFailed : action.payload
            }
        case types.GET_ALL_TRANSACTION_SUCCESS:
            return {
                ...state,
                getAllTransactions : action.payload
            }
        case types.GET_ALL_TRANSACTION_FAILED:
            return {
                ...state,
                getAllTransactionsFailed : action.payload
            }
        case types.GET_TRANSACTIONS_BY_USER_ID_SUCCESS:
            return {
                ...state,
                getTransactionByUserId : action.payload
            }
        case types.GET_TRANSACTIONS_BY_USER_ID_FAILED:
            return {
                ...state,
                getTransactionByUserIdFailed : action.payload
            }
        
        default:
            return state
    }
}